import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent, HttpResponse, HttpHeaders} from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { InfoSeparador, DocumentoSol, AutenticaRS, GetSoporteRQ, ValidaPerfil, ConfiguraEstCredito, TipoDocumento, MsgRta, EliminaDocRQ, ValidaCargaRQ, GuardaErrorRQ } from '../Interfaces';
import { Usuario } from '../models/usuario';
import { Login } from '../models/login';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
}

const httpOptionsMulti = {
  headers: new HttpHeaders({
    'Content-Type': 'multipart/form-data'
  })
}
  //,'Authorization': 'my token'

@Injectable({
  providedIn: 'root'
})
  

export class FDLMService {
  urlBase: string = "";
  apiFDLMEndPoint: string = "";
  private baseApiUrl: string;
  public redirectUrl: string;
 // private apiDownloadUrl: string;

  private usuarioSubject: BehaviorSubject<Usuario>;
  public usuario: Observable<Usuario>

  public get usuarioData(): Usuario {
    return this.usuarioSubject.value;
  }

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl:string) {
    this.urlBase = baseUrl;
    this.apiFDLMEndPoint = environment.apiFDLMEndPoint;
    this.usuarioSubject = new BehaviorSubject<Usuario>(JSON.parse(localStorage.getItem('usuario')));
    this.usuario = this.usuarioSubject.asObservable();
  }



  public GetSeparadorXNumSolicitud(parNumSolicitud: string, parIdEmpSede: string): Observable<InfoSeparador[]>
  {
    let lstInfoSeparador: Observable<InfoSeparador[]>;
    const urlService: string = this.urlBase + "api/SeparadorXNumSolicitud/GetInfoSeparadorXNumSolicitud/" + parNumSolicitud + '/' + parIdEmpSede;
    lstInfoSeparador = this.httpClient.get<InfoSeparador[]>(urlService);
    return lstInfoSeparador;
  }

  public GetTblInfoDocumentosXNumSolicitud(parNumSolicitud: string, parIdEmpSede: string) {
    let lstDocumentos: Observable<DocumentoSol[]>;
    const urlService: string = this.urlBase + "api/DocumentosXSeparador/GetTblInfoDocumentosXNumSolicitud/" + parNumSolicitud + '/' + parIdEmpSede;
    lstDocumentos = this.httpClient.get<DocumentoSol[]>(urlService);
    return lstDocumentos
  }

  public login(login: Login): Observable<AutenticaRS> {
    const urlService: string = this.urlBase + "api/usuUsuario/login"
    return this.httpClient.post<AutenticaRS>(urlService, login, httpOptions).pipe(
      map(res => {
        if (res.idEstado === 1) {
          const usuario: Usuario = res;
          localStorage.setItem('usuario', JSON.stringify(usuario));
          this.usuarioSubject.next(usuario);
        }
        return res;
      })
    );
  }

  logout() {
    localStorage.removeItem('usuario');
    this.usuarioSubject.next(null );
  }

  //FUNCION PARA CARGAR INFORMACION DE TIPO DOCIUMENTO POR TRD PARAMETRIZADA
  public GetTblInfoTipoDocumentoXTRDParams(parIdEmpSede: string): Observable<TipoDocumento[]> {
    let lstTipoDoc: Observable<TipoDocumento[]>;
    const urlService: string = this.urlBase + "api/TipoDocumento/GetTblInfoTipoDocumentoXTRDParams/" + parIdEmpSede;
    lstTipoDoc = this.httpClient.get<TipoDocumento[]>(urlService);
    return lstTipoDoc
  }

  //FUNCION PARA GENERAR UBICACION DEL ARCHIVO SEPARADOR POR NUM_SOLICITUD
  public GenerarUbiCabArchivoSeparadorxNumSolicitud(parNumSolicitud: string, parIdTipoDocumento: string) {

    const urlService: string = this.urlBase + "api/ArchivoSeparador/GenerarUbiCabArchivoSeparadorxNumSolicitud/" + parNumSolicitud + '/' + parIdTipoDocumento;

    return this.httpClient.get(urlService).pipe(map((result: any) => {
      return result;
    }));
  }

  public GuardaArch(formData): Observable<MsgRta> {
    const urlService: string = this.urlBase + "api/GuardaArch";
    return this.httpClient.post<any>(urlService, formData).pipe(
      map(res => { return res; }));
  }

  //FUNCION PARA CARAGAR INFORMACION DE SOPORTE
  public CargarInfoSopData(parIdSoporte: string) {

    const urlService: string = this.urlBase + "api/ArchivoSeparador/CargarInfoSopData/" + parIdSoporte;

    return this.httpClient.get(urlService).pipe(
      map((result: any) => {
      return result;
    }));
  }

  public GetSoporte(parGetSoporteRQ: GetSoporteRQ): Observable<any> {
    const urlService: string = this.urlBase + 'api/GetSoporte/GetSoporte';
    return this.httpClient.post(urlService, parGetSoporteRQ, { responseType: 'blob' })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  public EliminaDoc(parEliminaDocRQ: EliminaDocRQ): Observable<any> {
    const urlService: string = this.urlBase + 'api/EliminaDocumento';
    return this.httpClient.post(urlService, parEliminaDocRQ)
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }



  public ValidaCargaDoc(parNumSolicitud :string, parIdTipoDoc: number): Observable<MsgRta> {

    var oValidaCargaRQ = <ValidaCargaRQ>{
      parNumSolicitud: parNumSolicitud,
        parIdTipoDoc: parIdTipoDoc
    }
   const urlService: string = this.urlBase + "api/ValidaCargaDoc";
    return this.httpClient.post<any>(urlService, oValidaCargaRQ).pipe(
      map(res => { return res; }));
  }


  //FUNCION PARA DESCARGAR ARCHIVO
  //public DescargarArchivo(parIdSoporte: string): Observable<HttpEvent<Blob>> {
  //  const urlService: string = this.urlBase + "api/ArchivoSeparador/DescargarArchivo/" + parIdSoporte;

  //  return this.httpClient.request(new HttpRequest(
  //    'GET',
  //    `${urlService}?parIdSoporte=${parIdSoporte}`,
  //    null,
  //    {
  //      reportProgress: true,
  //      responseType: 'blob'
  //    }));
  //}

  //FUNCION PARA GUARDAR AUDITORIA SOBRE DOCUMENTO
  public GuardarAuditoriaCDocCabVer(parInfoAudCabVer: any) {
    try
    {
      const urlService: string = this.urlBase + "api/AuditoriaCDoc/GuardarAuditoriaCDocCabVer";


      //const headers = new HttpHeaders()
      //  .set("Content-Type", "application/json")
      //  .set("Access-Control-Allow-Origin", "*")
      //  .set("Access-Control-Allow-Methods", "GET,POST,OPTIONS,DELETE,PUT")
      //  .set("Access-Control-Allow-Credentials", "true");


      return this.httpClient.post(urlService, parInfoAudCabVer)
        .pipe(
          map((data => {
            return data;
          })), catchError(error => {
            //infoError = error

            //const errorSrv = {
            //  Estado: "-1",
            //  Codigo: "-1",
            //  Mensaje: infoError
            //}
            console.error("Error consumiendo servicio GuardarAuditoriaCDocCabVer: ", error);
            return error;

          })
        )
    }
    catch (error) {
      console.error("Error", error);
    }
  }

  //FUNCION PARA VALIDAR PERFIL USUARIO AUTENTICACION
  public ValidaPerfilUsuAutenticaXNumSol(parNumSolicitud: string, parIdCreaSol: string): Observable<ValidaPerfil[]> {
    let lstValidaPerfil: Observable<ValidaPerfil[]>;
    const urlService: string = this.urlBase + "api/PerfilUsuario/ValidaPerfilUsuAutenticaXNumSol/" + parNumSolicitud + '/' + parIdCreaSol;
    lstValidaPerfil = this.httpClient.get<ValidaPerfil[]>(urlService);
    return lstValidaPerfil;
  }
  //FUNCION PARA CARGAR INFORMACION DE CONFIGURACION ESTADO_CREDITO
  public GetConfiguraEstCreditoXNumSolicitud(parNumSolicitud: string, parIdEmpSede: string): Observable<ConfiguraEstCredito[]> {
    let lstConfiguraEstCredito: Observable<ConfiguraEstCredito[]>;
    const urlService: string = this.urlBase + "api/SeparadorXNumSolicitud/GetConfiguraEstCreditoXNumSolicitud/" + parNumSolicitud + '/' + parIdEmpSede;
    lstConfiguraEstCredito = this.httpClient.get<ConfiguraEstCredito[]>(urlService);
    return lstConfiguraEstCredito;
  }

  public GuardaError(parCodigo: string, parMensaje: string, parUrl: string, parOrigen: string): Observable<any> {
    var oGuardaErrorRQ = <GuardaErrorRQ>{
      Codigo: parCodigo,
      Mensaje: parMensaje,
      url: parUrl,
      Origen: parOrigen
    }
    const urlService: string = this.urlBase + "api/GuardaError";
    return this.httpClient.post<any>(urlService, oGuardaErrorRQ).pipe(
      map(res => {
          return res;
      }), catchError(error => {
        console.error("Error Guardando: ", error);
        return error;
      })
    );
  }

}
